(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["turtleson-brand-story"] && !Shopify.designMode) return;
  try {
    

(()=>{
 const init=(root)=>{
  if(root.dataset.tbsReady)return;
  root.dataset.tbsReady='true';
  const header=document.querySelector('.header__outer-wrapper');
  if(header){const syncHeader=()=>root.style.setProperty('--tbs-header-height',header.getBoundingClientRect().height+'px');syncHeader();if('ResizeObserver' in window)new ResizeObserver(syncHeader).observe(header)}
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce&&'IntersectionObserver' in window){
   root.classList.add('tbs-motion');
   const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('tbs-pending');reveal.unobserve(entry.target)}}),{threshold:.07});
   root.querySelectorAll('[data-tbs-reveal]').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('tbs-pending');reveal.observe(el)}});
  }
  root.querySelectorAll('[data-stitch-gallery]').forEach(gallery=>{
   const track=gallery.querySelector('[data-stitch-track]'),slides=Array.from(track.children),prev=gallery.querySelector('[data-stitch-prev]'),next=gallery.querySelector('[data-stitch-next]'),count=gallery.querySelector('[data-stitch-count]');
   if(!slides.length)return;
   let current=0,timer;
   const update=()=>{current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));prev.disabled=current===0;next.disabled=current===slides.length-1;count.textContent=(current+1)+' / '+slides.length};
   const move=delta=>{current=Math.max(0,Math.min(slides.length-1,current+delta));track.scrollTo({left:current*track.clientWidth,behavior:reduce?'instant':'smooth'})};
   prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(update,120)},{passive:true});
   track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}});
   if('ResizeObserver' in window)new ResizeObserver(()=>{track.scrollTo({left:current*track.clientWidth,behavior:'instant'});update()}).observe(track);
   update();
  });
  root.querySelectorAll('[data-logic-chapter]').forEach(chapter=>chapter.addEventListener('toggle',()=>{
   if(!chapter.open)return;
   root.querySelectorAll('[data-logic-chapter]').forEach(other=>{if(other!==chapter)other.open=false});
   root.querySelectorAll('[data-logic-image]').forEach(img=>img.classList.toggle('is-active',img.dataset.logicImage===chapter.dataset.logicChapter));
  }));
  root.querySelectorAll('.tbs-nav a,.tbs-hero a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
   const target=document.getElementById(link.hash.slice(1));if(!target)return;
   event.preventDefault();target.scrollIntoView({behavior:reduce?'instant':'smooth',block:'start'});
   history.replaceState(null,'',link.hash);
  }));
  if('IntersectionObserver' in window){
   const nav=root.querySelector('.tbs-nav');
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)nav.querySelectorAll('a').forEach(a=>{const active=a.hash==='#'+entry.target.id;a.classList.toggle('is-active',active);if(active)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')})}),{rootMargin:'-15% 0px -60% 0px'});
   nav.querySelectorAll('a').forEach(a=>{const target=document.getElementById(a.hash.slice(1));if(target)observer.observe(target)});
  }
 };
 document.querySelectorAll('[data-tbs]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-tbs]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["turtleson-fit-guide"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('turtleson-fit-guide')) {
  customElements.define('turtleson-fit-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[data-audience]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectAudience(tab.dataset.audience));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') target = (index + 1) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.tabs[target].focus();
          this.selectAudience(this.tabs[target].dataset.audience);
        });
      });
      this.querySelectorAll('[data-switch-women]').forEach(button => button.addEventListener('click', () => {
        this.selectAudience('women');
        this.tabs[1].focus({ preventScroll: true });
        this.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
      }));
    }
    selectAudience(audience) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.audience === audience;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== audience;
        if (!panel.hidden && !this.reducedMotion) panel.animate([{ opacity: .35, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'ease-out' });
      });
    }

  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-wl-review-toggle]');
    if(!button)return;
    const expanded=button.getAttribute('aria-expanded')!=='true';
    button.setAttribute('aria-expanded',String(expanded));
    button.closest('.wl-product-reviews').dataset.expanded=String(expanded);
    button.innerHTML=expanded?'Show fewer reviews <span aria-hidden="true">↑</span>':'View more reviews <span aria-hidden="true">↓</span>';
  });

  } catch(e) { console.error(e); }
})();
})();
